import Debug from 'debug';
import * as React from 'react';
import { FormCheck } from 'react-bootstrap';
import { BooleanField } from 'gossamer-unified';
import { FormControl } from './FormControl';

const debug = Debug('gfe/fi/Boolean');

export interface BooleanProps {
  editable: boolean;
  field: BooleanField;
  handleChange?: (newValue: string) => void;
  validity?: boolean;
  value: string;
}

const BooleanUneditable: React.FC<BooleanProps> = (props) => {
  return <span>{props.value === 'true' ? 'yes' : 'no'}</span>;
};

const BooleanEditable: React.FC<BooleanProps> = (props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.handleChange?.(event.target.checked ? 'true' : 'false');
  };
  return (
    <FormControl validity={props.validity}>
      <FormCheck type="switch" checked={props.value === 'true'} onChange={handleChange} />
    </FormControl>
  );
};

export const Boolean: React.FC<BooleanProps> = (props) => {
  return (
    <>
      {props.editable && <BooleanEditable {...props} />}
      {!props.editable && <BooleanUneditable {...props} />}
    </>
  );
};
